<ng-template #helpPanel><custom-deal-types-help-panel></custom-deal-types-help-panel></ng-template>
<div class="content-area">
    <div class="left-panel">
        <div class="card">
            <div class="left-panel-title">
                Select Existing Custom Deal Type
                <mat-icon
                    matTooltip="Select a deal type from the list below to view or modify it. NOTE: Changes to custom deal types will not impact any existing Deal Jackets. They will only be applied to Deal Jackets created after the deal type has been updated. Deleting a deal type will also not affect any existing Deal Jackets."
                    class="info-type"
                >
                    info
                </mat-icon>
            </div>

            <mat-list *ngIf="groups.length >= 1; else noGroups">
                <mat-list-item
                    [ngClass]="group?.templateGroupId === selectedGroup?.templateGroupId ? 'list-item-selected' : 'list-item'"
                    *ngFor="let group of groups"
                    (click)="editGroup(group)"
                    >{{ group?.groupName }}
                </mat-list-item>
            </mat-list>
        </div>
        <ng-template #noGroups>
            <p class="no-groups">No Custom Deal Types have been created yet</p>
        </ng-template>
    </div>
    <div class="right-panel">
        <div [ngClass]="createClicked ? 'instruction-button-container clicked' : 'instruction-button-container'">
            <span *ngIf="createClicked" class="instruction">Complete all sections below to add a new Custom Deal Type.</span>
            <button mat-button class="create-button primary" (click)="createNew()">Create Custom Deal Type</button>
        </div>
        <form [formGroup]="createGroupForm" (ngSubmit)="saveGroup()">
            <div class="card">
                <h3 id="scrollTo">
                    Custom Deal Type Name
                    <mat-icon
                        matTooltip="Add or edit the deal type name. Use a unique and descriptive name so you can easily find it when you are creating a Deal Jacket."
                        class="info-type"
                    >
                        info
                    </mat-icon>
                </h3>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <p class="required-indication">*Indicates a required field</p>
                    <mat-form-field style="width: 100%" class="col">
                        <mat-label>Name*</mat-label>
                        <input class="form-control" type="text" matInput formControlName="name" autocomplete="off" maxlength="250" />
                        <mat-error *ngIf="createGroupForm.status === 'INVALID' && createGroupForm.get('name')?.touched">Name is required</mat-error>
                    </mat-form-field></mat-card-content
                >
            </div>

            <div class="card" formArrayName="templates">
                <mat-card-content>
                    <h3>
                        Forms included in Deal Type
                        <mat-icon
                            matTooltip="Forms included in the deal type are checked. You can add or delete forms by clicking the checkbox next to the form name. NOTE: Forms and documents must be created through F&I Forms before they can be added to deal types. System documents required for every deal type cannot be unchecked."
                            class="info-type"
                        >
                            info
                        </mat-icon>
                    </h3>
                    <mat-divider></mat-divider>
                    <br />
                    <div class="templates-container">
                        <mat-checkbox (change)="selectAll()" [checked]="selectAllTemplatesCheckbox">Select All </mat-checkbox>
                        <div class="select-all-check-underline"></div>
                    </div>

                    <p *ngIf="noSelectedTemplatesError" class="error">You must select at least one document</p>

                    <div *ngFor="let template of templateArray.controls; let i = index" [formGroupName]="i" class="templates-container">
                        <mat-checkbox [formControlName]="templates[i].displayName" (change)="checked(templates[i])" [checked]="templates[i].checked"
                            >{{ templates[i].displayName }}
                        </mat-checkbox>
                    </div>
                </mat-card-content>
            </div>
            <div class="button-container">
                <button mat-button type="button" class="secondary" (click)="resetGroup()">Cancel</button>
                <ng-container *ngIf="selectedGroup">
                    <button mat-button type="button" class="delete-btn" (click)="deleteGroup()">Delete</button>
                </ng-container>
                <button mat-button class="primary" type="submit">Save</button>
            </div>
        </form>
    </div>
</div>
<div class="loading-page" *ngIf="isLoading"></div>
